import { render } from "./AreaData.vue?vue&type=template&id=0098fa90&scoped=true"
import script from "./AreaData.vue?vue&type=script&lang=js"
export * from "./AreaData.vue?vue&type=script&lang=js"

import "./AreaData.vue?vue&type=style&index=0&id=0098fa90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0098fa90"]])

export default __exports__